import React from "react";

function FilterFunnelIcon({ className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
    >
      <path d="M4 5h16l-6.2 7.4V20l-3.6-2v-5.6L4 5z" />
    </svg>
  );
}

export default function CatalogFilterButton({ count = 0, onClick, className = "" }) {
  const filterCount = Number.isFinite(Number(count)) ? Number(count) : 0;

  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={`Filters (${filterCount})`}
      className={[
        "inline-flex h-11 shrink-0 items-center justify-center gap-1 rounded-full border border-[#7352C7] bg-[#7352C7] px-3 text-white shadow-sm",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
    >
      <span className="text-[14px] font-semibold leading-none">({filterCount})</span>
      <FilterFunnelIcon className="h-5 w-5" />
    </button>
  );
}
